var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scan"},[_c('qrcode-stream',{attrs:{"track":_vm.paintBoundingBox},on:{"detect":_vm.onDetect,"error":_vm.onError}}),_c('div',{staticStyle:{"padding-top":"5px"}},[_vm._v(_vm._s(_vm.result))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }